import { createContext, useContext } from "react";

const ThemeContext = createContext({ theme: "dark", toggle: () => {} });

export const ThemeProvider = ({ children }) => {
  // Dark-only mode (theme toggle removed by request)
  if (typeof document !== "undefined") {
    document.documentElement.classList.add("dark");
  }
  return (
    <ThemeContext.Provider value={{ theme: "dark", toggle: () => {} }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
